import { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../../contexts/AuthContext';

/**
 * Tar emot JWT-tokenen efter Discord eller Steam OpenID-login och stoppar
 * in den i AuthContext. Routar till /pending om Steam-login lämnade
 * användaren som pending — annars till framsidan.
 *
 * Sprint 2 av Fluxer-migrationen: Steam-login-callbacken inkluderar
 * access_status som query-param så vi kan routa innan fetchUser() hinner
 * uppdatera kontexten.
 */
export default function AuthCallback() {
  const { t } = useTranslation();
  const [searchParams] = useSearchParams();
  const { handleCallback } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    const token = searchParams.get('token');
    const accessStatus = searchParams.get('access_status');
    if (!token) return;

    handleCallback(token);

    // Om vi sparade en invite-kod innan login-redirect, ta användaren
    // tillbaka till /pending med koden förifylld så de kan lösa in direkt.
    const pendingInvite = localStorage.getItem('pending_invite');
    if (pendingInvite) {
      localStorage.removeItem('pending_invite');
      navigate(`/pending?invite=${encodeURIComponent(pendingInvite)}`, { replace: true });
      return;
    }

    if (accessStatus && accessStatus !== 'active') {
      navigate('/pending', { replace: true });
    } else {
      navigate('/', { replace: true });
    }
  }, [searchParams, handleCallback, navigate]);

  return <div className="auth-callback">{t('auth.loggingIn')}</div>;
}
